// Camera waypoints — per-section camera positions for cinematic navigation

export interface CameraWaypoint {
  position: [number, number, number];
  target: [number, number, number];
  fov: number;
}

export const WAYPOINTS: Record<string, CameraWaypoint> = {
  '/':           { position: [0, 5, 20],   target: [0, 0, 0],   fov: 60 },
  '/expertise':  { position: [15, 8, 15],  target: [10, 2, 0],  fov: 55 },
  '/references': { position: [-10, 6, 18], target: [-5, 1, 0],  fov: 55 },
  '/about':      { position: [0, 10, 25],  target: [0, 3, 0],   fov: 50 },
  '/contact':    { position: [5, 4, 12],   target: [3, 1, 0],   fov: 65 },
};

export function getWaypoint(): CameraWaypoint {
  const path = window.location.pathname
    .replace(/\/index\.html$/, '/')
    .replace(/\.html$/, '')
    .replace(/\/$/, '') || '/';
  return WAYPOINTS[path] || WAYPOINTS['/'];
}
